export default __webpack_public_path__ + "static/media/GreenCityBlock.89884522.png";